<div class="editor-stage">
  <div
    class="label mx-auto my-0 overflow-hidden"
    [style.width.mm]="label().widthMm"
    [style.height.mm]="label().heightMm"
    [style.background-color]="label().backgroundColor"
    [style.position]="'relative'"
  >
    <!-- Imagem de fundo sobrepondo a cor, mas abaixo dos elementos -->
    @if (label().backgroundImageUrl) {
      <img
        [src]="label().backgroundImageUrl"
        class="absolute inset-0 w-full h-full pointer-events-none"
        [style.object-fit]="label().backgroundObjectFit ?? 'cover'"
        [style.z-index]="0"
      />
    }
    <!-- guia vertical opcional (centro) -->
    @if (showCenterGuide()) {
      <div class="center-guide"></div>
    }

    @for (el of elements(); track el.id) {
      <div
        class="element"
        [class.selected]="el.id === selectedId()"
        [style.left.mm]="el.xMm"
        [style.top.mm]="el.yMm"
        [style.width.mm]="el.wMm"
        [style.height.mm]="el.hMm"
        [style.z-index]="el.zIndex"
        (mousedown)="select.emit(el.id)"
        cdkDrag
        [cdkDragBoundary]="'.label'"
        (cdkDragEnded)="onDragEnd($event, el.id)"
        appResizable
        [resizableDisabled]="el.id !== selectedId()"
        (resizeEnd)="onResizeEnd($event, el.id)"
      >
        @if (el.type === 'image') {
          <img
            [src]="$any(el).src"
            [style.width.%]="100"
            [style.height.%]="100"
            [style.object-fit]="$any(el).objectFit"
            draggable="false"
          />
        } @else {
          <div
            class="text"
            [style.color]="$any(el).color"
            [style.font-family]="$any(el).fontFamily"
            [style.font-size.pt]="$any(el).fontSizePt"
            [style.text-align]="$any(el).textAlign"
            [style.font-weight]="$any(el).fontWeight ?? 'normal'"
            [style.font-style]="$any(el).fontStyle ?? 'normal'"
            [style.text-decoration]="$any(el).textDecoration ?? 'none'"
            [style.letter-spacing]="getLetterSpacing($any(el))"
            [style.line-height]="getLineHeight($any(el))"
          >
            {{ resolvePlaceholders($any(el).text) }}
          </div>
        }
      </div>
    }
  </div>
</div>
